// extracted by mini-css-extract-plugin
module.exports = {"CameraView":"cameraview_CameraView__B9zfz","fade":"cameraview_fade___MpvA"};